<app-form-input
	[parentForm]="parentForm"

	[disabled]="disabled"
	[value]="lot.description"

	[label]="step4.description"
	[type]="'text'"
	[rule]="'minSize_5|maxSize_2000|required'"
	[name]="getUid() + '_SepAtt_description'"
>
</app-form-input>

<!---->

<app-type-objCPV
	[uid]="getUid()"
	[parentForm]="parentForm"

	[disabled]="disabled"
	[codeCPV]="lot.codeCPV"
  [i]="i"
  (prefEmit)="chargeDonneePreference($event)"
></app-type-objCPV>

<!---->

<app-type-montant
	[uid]="getUid()"
	[parentForm]="parentForm"
	[i]="i"
	[disabled]="disabled"
	[estimationValeur]="lot.estimationValeur"
></app-type-montant>

<!---->

<app-form-input
	[parentForm]="parentForm"
	[disabled]="disabled"
	[value]="lot.lieuExecutionLivraison"
	[label]="step4.lieuExecutionLivraison"
	[type]="'text'"
	[rule]="'minSize_5|maxSize_2000|required'"
	[name]="getUid() + '_SepAtt_lieuExecutionLivraison'"
>
</app-form-input>
